import { typedQueryClient, useTypedQuery } from "hooks";
import { API_KEY_TYPES } from "models";
import { ApiKeys } from "modules/ApiKeys/queryKeys";

export type ApiKeysFilters = {
  api_key_type: API_KEY_TYPES | null;
  term: string;
};

export const useKeysFilters = () => useTypedQuery({ queryKey: ApiKeys.filters, initialData: { api_key_type: null, term: "" } }).data;

export const useKeysFilterUpdate = () => {
  const filters = useKeysFilters();
  return (newFilters: Partial<ApiKeysFilters>) => typedQueryClient.setQueryData(ApiKeys.filters, { ...filters, ...newFilters });
};
